import { AppShell, Box, Center, Loader, Stack } from '@mantine/core'
import { useUserRole } from '@ospace/auth'
import { useCampaign } from '@ospace/campaign'
import { Notifications } from '@mantine/notifications'
import { useUser } from '@ospace/user'
import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'

import { useSideNav } from '../../hooks/useSideNav'
import { CustomHeader } from '../CustomHeader'
import { Footer } from '../Footer'
import { PageId, SideNavbar } from '../SideNavbar'
import classes from './index.module.css'
import ProgramHeader from './ProgramHeader'
import ProgramNavigation from './ProgramNavigation'

type Props =
  | {
      status: 'ready'
      pageId: PageId
      children: ReactElement
      subHeader?: ReactElement
      pageTitle?: string
      fluid?: boolean
    }
  | {
      status: 'loading'
      pageId: PageId
      pageTitle?: string
      subHeader?: ReactElement
      fluid?: boolean
    }
  | {
      status: 'error'
      pageId: PageId
      pageTitle?: string
      subHeader?: ReactElement
      fluid?: boolean
      message: string
    }

export const ProgramLayout = (props: Props) => {
  const role = useUserRole()
  const user = useUser()
  const params: any = useParams()
  const programId = Number(params?.id)

  const { data: campaign, isSuccess } = useCampaign(programId)

  const { opened, setOpened } = useSideNav()

  if (user.status !== 'success' || !isSuccess) {
    return (
      <Center style={{ minHeight: '100vh' }} h='100vh' mx='auto'>
        <Loader variant='bars' />
      </Center>
    )
  }

  return (
    <>
      <Notifications />
      <AppShell
        className={classes.main}
        navbar={{
          width: opened ? { base: 300, sm: 300, md: 300, lg: 300 } : { base: 100 },
          breakpoint: 'sm',
          collapsed: { mobile: !opened },
        }}
      >
        <SideNavbar
          activePageId={props.pageId}
          setOpened={setOpened}
          opened={opened}
          user={user.data}
          role={role}
          client={campaign.client}
        />
        <AppShell.Main className={classes.mainContainer}>
          <CustomHeader
            user={user.data}
            role={role}
            client={campaign.client || campaign.client}
            subHeader={<ProgramHeader campaign={campaign} />}
            pageTitle={campaign?.name || ''}
          />
          <ProgramNavigation campaign={campaign} />
          <Box
            className={classes.innerPage}
            maw={props.fluid ? '100%' : 1600}
            m='auto'
            px='xl'
            pb='xl'
          >
            {props.status === 'ready' ? props.children : null}
            {props.status === 'loading' ? (
              <Center style={{ minHeight: '100vh' }} h='100vh' mx='auto'>
                <Loader variant='bars' role='alert' aria-label='loading' />
              </Center>
            ) : null}
            {props.status === 'error' ? props.message : null}
          </Box>
          <Footer />
        </AppShell.Main>
      </AppShell>
    </>
  )
}
